<template>
  <v-container
    v-if="client"
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
        class="text-right"
      >
        <v-btn-toggle
          v-model="language"
          mandatory
        >
          <v-btn
            value="fr"
            text
            color="info"
            @click="changeLanguage('fr')"
          >
            {{ $t('French') }}
          </v-btn>
          <v-btn
            value="en"
            text
            color="info"
            @click="changeLanguage('en')"
          >
            {{ $t('English') }}
          </v-btn>
        </v-btn-toggle>
      </v-col>

      <v-col
        cols="12"
      >
        <!-- Mobile-->
        <v-btn-toggle
          v-if="isMobile"
          v-model="toggleButton"
          mandatory
        >
          <!--Contrat -->
          <v-btn
            value="contrat"
            text
            color="blue"
            @click="toggleButton = 'contrat'"
          >
            <v-icon
              center
              color="blue"
            >
              mdi-phone
            </v-icon>
          </v-btn>

          <!-- Autre facture-->
          <v-btn
            value="factureAutre"
            text
            color="blue"
            @click="toggleButton = 'factureAutre'"
          >
            <v-icon
              center
              color="blue"
            >
              mdi-file-document-outline
            </v-icon>

            <!-- Îcone pour les facture non payé-->
            <v-icon
              v-if="unpaidUnvoiceState"
              class="ml-1"
              left
              dark
              small
              color="yellow accent-3"
            >
              mdi-alert
            </v-icon>
          </v-btn>

          <!-- Commande-->
          <v-btn
            value="commande"
            text
            color="blue"
            @click="toggleButton = 'commande'"
          >
            <v-icon
              center
              color="blue"
            >
              mdi-cart-plus
            </v-icon>
          </v-btn>

          <!-- Mes Commandes-->
          <!-- On affiche pas si il n'y a pas de commandes-->
          <v-btn
            v-if="client.Commandes.length"
            value="mesCommandes"
            text
            color="blue"
            @click="toggleButton = 'mesCommandes'"
          >
            <v-icon
              center
              color="blue"
            >
              mdi-cart-outline
            </v-icon>

            <!-- On regarde si il y a une commande avec le status 2-->
            <v-icon
              v-if="checkCommandeStatus2"
              class="ml-1"
              left
              dark
              small
              color="yellow accent-3"
            >
              mdi-alert
            </v-icon>
          </v-btn>

          <!-- Commandes pour les responsable-->
          <v-btn
            v-if="ifUbrResponsable"
            value="commandesResponsable"
            text
            color="blue"
            @click="toggleButton = 'commandesResponsable'"
          >
            <v-icon
              center
              color="blue"
            >
              mdi-cart-check
            </v-icon>

            <!-- On regarde si il y a des commandes à approuver pour le responsable-->
            <v-icon
              v-if="ubrResponsableOrders.length"
              class="ml-1"
              left
              dark
              small
              color="yellow accent-3"
            >
              mdi-alert
            </v-icon>
          </v-btn>
        </v-btn-toggle>

        <!-- Pas mobile-->
        <v-btn-toggle
          v-else
          v-model="toggleButton"
          mandatory
        >
          <!--Contrat -->
          <v-btn
            value="contrat"
            text
            color="blue"
            @click="toggleButton = 'contrat'"
          >
            <v-icon
              center
              class="mr-1"
              color="blue"
            >
              mdi-phone
            </v-icon>

            {{ $t('sidebar.my_contracts') }}
          </v-btn>

          <!-- Autre facture-->
          <v-btn
            value="factureAutre"
            text
            color="blue"
            @click="toggleButton = 'factureAutre'"
          >
            <v-icon
              center
              class="mr-1"
              color="blue"
            >
              mdi-file-document-outline
            </v-icon>

            <!-- UnPaid-->
            <v-icon
              v-if="unpaidUnvoiceState"
              left
              dark
              color="yellow accent-3"
            >
              mdi-alert
            </v-icon>
            {{ $t('invoices.Other_invoices') }}
          </v-btn>

          <!-- Mes Commandes-->
          <!-- On affiche pas si il n'y a pas de commandes-->
          <v-btn
            v-if="client.Commandes.length"
            value="mesCommandes"
            text
            color="blue"
            @click="toggleButton = 'mesCommandes'"
          >
            <v-icon
              center
              class="mr-1"
              color="blue"
            >
              mdi-cart-outline
            </v-icon>

            <!-- On regarde si il y a une commande avec le status 2-->
            <v-icon
              v-if="checkCommandeStatus2"
              left
              dark
              color="yellow accent-3"
            >
              mdi-alert
            </v-icon>
            {{ $t('order.My_orders') }}
          </v-btn>

          <!-- Commander-->
          <v-btn
            value="commande"
            text
            color="blue"
            @click="toggleButton = 'commande'"
          >
            <v-icon
              center
              class="mr-1"
              color="blue"
            >
              mdi-cart-plus
            </v-icon>

            {{ $t('order.name') }}
          </v-btn>

          <!-- Commandes pour les responsable-->
          <v-btn
            v-if="ifUbrResponsable"
            value="commandesResponsable"
            text
            color="blue"
            @click="toggleButton = 'commandesResponsable'"
          >
            <v-icon
              center
              color="blue"
            >
              mdi-cart-check
            </v-icon>

            <!-- On regarde si il y a des commandes à approuver pour le responsable-->
            <v-icon
              v-if="ubrResponsableOrders.length"
              class="ml-1"
              left
              dark
              small
              color="yellow accent-3"
            >
              mdi-alert
            </v-icon>

            {{ $t('order.commandesResponsable') }}
          </v-btn>
        </v-btn-toggle>
      </v-col>

      <v-col
        cols="12"
      >
        <!-- <div
          class="font-weight-light mt-1"
          style="font-size: 25px"
        >
          {{ $t('contract.Your_cell_lines') }}
        </div> -->
      </v-col>

      <v-container
        id="client"
        fluid
        tag="section"
      >
        <!--  On regarde si il y a des contrats-->
        <template v-if="client.Contrats">
          <!--  Facture autres-->
          <facture-autre
            v-show="toggleButton === 'factureAutre'"
            :client="client"
            :client-id="client.id"
            @unpaid-invoice="unpaidUnvoice"
            @return-to-contract="toggleButton = 'contrat'"
          />
          <!--  Contract-->
          <contract
            v-show="toggleButton === 'contrat'"
            :client-contrats="client.Contrats"
          />
          <!--  Commande-->
          <order
            v-show="toggleButton === 'commande'"
            ref="order"
            :client="client"
          />
          <!--  Mes commandes-->
          <my-orders
            v-show="toggleButton === 'mesCommandes'"
            :client="client"
            :order-step="orderStep"
          />

          <!-- Commandes pour les responsable-->
          <responsible-orders
            v-show="toggleButton === 'commandesResponsable'"
            :ubr-responsable-orders="ubrResponsableOrders"
          />
        </template>
      </v-container>
    </v-row>
  </v-container>
</template>

<script>
  // Components
  import Contract from '@/components/Client/Contract'
  import FactureAutre from '@/components/Client/Facture/FactureAutre'
  import Order from '@/components/Client/Order/Order'
  import MyOrders from '@/components/Client/Order/MyOrders'
  import ResponsibleOrders from '@/components/Client/Order/ResponsibleOrders'
  // Service
  import ClientsService from '@/services/01Cell/ClientsService'

  // Mixins
  import { Payment } from '@/mixins/Payment/Payment'
  // Other
  import { mapState, mapGetters } from 'vuex'
  import { EventBus } from '@/utils/event-bus'
  import { isMobile } from 'mobile-device-detect'
  import { localize } from 'vee-validate'
  // Utils
  import { orderStep } from '@/utils/constants/order/step'

  export default {
    name: 'Dashboard',
    components: {
      Contract,
      FactureAutre,
      Order,
      MyOrders,
      ResponsibleOrders,
    },
    mixins: [Payment],
    data () {
      return {
        orderStep: orderStep,
        language: this.$i18n.t('Language'),
        isMobile: isMobile,
        client: {
          Commandes: [],
        },
        toggleButton: 'contrat', // contrat, factureAutre ou commande
        unpaidUnvoiceState: false,
        ifUbrResponsable: false,
        ubrResponsableOrders: [],
      }
    },

    computed: {
      ...mapState(['userInfo']),
      ...mapGetters('parameters', {
        parameterFournisseurPaiement: 'getFournisseurPaiement',
        parameterLanguage: 'getLanguage',
      }),
      checkCommandeStatus2 () {
        // Si Commande n'est pas défini, on retourne false
        if (!this.client.Commandes) return false
        // On regarde si il y a une commande avec la variable iconMesCommandes est true. si oui on affiche un icone de warning
        return this.client.Commandes.find(item => this.orderStep.type[item.type].statut[item.statut].etape[item.etape].mesCommandes.action.iconMesCommandes)
      },
    },

    mounted () {
      // Start Spinner
      this.$loading.show()

      // Récupération des infos sur le client
      this.getData()

      // Viens du composant 'components/Client/Order/MyOrders.vue'
      EventBus.$on('update-order', () => {
        // Start Spinner
        this.$loading.show()
        // Récupération des infos sur le client
        this.getData()
      })
    },

    destroyed () {
      // Viens du composant 'components/Client/Order/MyOrders.vue'
      EventBus.$off('update-order')
    },

    methods: {
      async getData () {
        try {
          const client = await ClientsService.query(this.userInfo.info.username, 'username')
          // Si le client est dans la base de donnée, il faut qu'il valide son profil si il manque des champs
          if (client) {
            this.client = client
            // Si le client est type 0, on mets à jour ses informations
            if (client.type === '0') {
              // Mise à jour du client avec le type 1
              ClientsService.update({
                nom: this.userInfo.info.name,
                prenom: this.userInfo.info.firstName,
                langue: this.parameterLanguage,
                email: this.userInfo.info.mail,
                type: '1', // Employé
              }, client.id)

              // Mise à jour des infos
              this.client.nom = this.userInfo.info.name
              this.client.prenom = this.userInfo.info.firstName
              this.client.langue = this.parameterLanguage
              this.client.email = this.userInfo.info.mail
              this.client.type = '1'
            } else {
              this.client = client
            }
          } else {
            // Création du client
            await ClientsService.save({
              username: this.userInfo.info.username,
              nom: this.userInfo.info.name,
              prenom: this.userInfo.info.firstName,
              langue: this.parameterLanguage,
              email: this.userInfo.info.mail,
              type: '1', // Employé
            })

            this.client = await ClientsService.query(this.userInfo.info.username, 'username')
          }
          // Stop Spinner
          this.$loading.hide()

          // Important on mets à jour les commandes pour les commandes payer par carte de crédit. Voir composant 'src/components/Client/Order/Order.vue'
          this.$nextTick(() => {
            this.$refs.order.updateOrder(this.client)
          })
        } catch (error) {
          console.log(error)
          // Stop Spinner
          this.$loading.hide()
        }
      },
      unpaidUnvoice (state, clientId) {
        this.unpaidUnvoiceState = state
      },
      changeLanguage (lang) {
        // On change le language de Vuetify
        this.$vuetify.lang.current = lang
        // Vee-validate
        localize(lang)
        // RTL
        this.$vuetify.rtl = false
        // I18N
        this.$i18n.locale = lang
        // Local Storage
        localStorage.setItem('APP_LANG_KEY', lang)
      },
    },
  }
</script>
